export { default } from "./DealsTab";
